setTimeout(function () {

    (function ($) {
        "use strict";

        // common variable
        var windowWidth = $(window).width(),
            windowHeight = $(window).height(),
            headTag = $('head'),
            body = $('body'),
            isMobile = windowWidth < 768;

        // function skillAndVideoBgRight() {
        //     var skillAndVideoWidth = $('.skill_and_video .container').width(),
        //         skillAndVideoHeight = $('.skill_and_video').height(),
        //         skillAndVideoRightWidth = (windowWidth - skillAndVideoWidth) / 2 - 15;
        //     $('.video_control').css('height', skillAndVideoHeight);
        //     $('<style>.col-sm-7.skillBg::after{width: calc(100% + ' + skillAndVideoRightWidth + 'px);}</style>').appendTo('head');
        // }

        //mean menu logo 
        // function meanMenuLogo() {
        //     // isMobile ? $('.mean-bar').prepend('<a href="/"><img alt="logo" src="template/img/logo.svg"></a>') : null;
        // }

        /*
        * Replace all SVG images with inline SVG
        */
        $('img.svg').each(function () {
            var $img = $(this),
                imgID = $img.attr('id'),
                imgClass = $img.attr('class'),
                imgURL = $img.attr('src');

            $.get(imgURL, function (data) {
                // Get the SVG tag, ignore the rest
                var $svg = $(data).find('svg');

                // Add replaced image's ID to the new SVG
                if (typeof imgID !== 'undefined') {
                    $svg = $svg.attr('id', imgID);
                }
                // Add replaced image's classes to the new SVG
                if (typeof imgClass !== 'undefined') {
                    $svg = $svg.attr('class', imgClass);
                }

                // Remove any invalid XML tags as per http://validator.w3.org
                $svg = $svg.removeAttr('xmlns:a');

                // Replace image with new SVG
                $img.replaceWith($svg);
            }, 'xml');

        });

        //window load event
        $(window).load(function () {
            // Preloader-js
            $('.preloader-area').fadeOut('1000');

            //mean menu logo
            // meanMenuLogo();

            // Skills section
            // skillAndVideoBgRight();

            // Jquery Parallax
            // $('.home-8 .project_area').parallax('50%', 0.2);
            // $('.home-8 .social_btn').parallax('50%', 0.2);

            //setTimeout function
            // setTimeout(function () {

            //     // Jquery Scroll Spay
            //     $('body').scrollspy({
            //         target: '.navbar-collapse',
            //         offset: 81
            //     });

            // }, 500);
        });

        //window resize event
        // $(window).resize(function () {
        //     windowWidth = $(window).width();
        //     windowHeight = $(window).height();
        //     isMobile = windowWidth < 768;
        // checkFeatures(); Se pasó al componente requerido
        // skillAndVideoBgRight();

        //Menu Line Height
        // MenuLineHeight(); Se pasó al componente requerido

        //mean menu logo 
        // meanMenuLogo();
        // });
    })(jQuery);
}, 1000);